import React, { useState, useEffect } from 'react';
import './UserProfile.css';
import { getToken, removeToken, getAuthHeaders } from '../utils/auth';

const API_BASE = '';

function UserProfile({ user, onLogout, onClose }) {
  const [rateLimit, setRateLimit] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRateLimit = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/rate-limit`, {
          headers: getAuthHeaders(),
        });
        if (response.ok) {
          const data = await response.json();
          setRateLimit(data);
        }
      } catch (error) {
        console.error('Error fetching rate limit:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRateLimit();
  }, []);

  const handleLogout = () => {
    removeToken();
    onLogout();
    onClose();
  };

  return (
    <div className="profile-overlay" onClick={onClose}>
      <div className="profile-modal" onClick={(e) => e.stopPropagation()}>
        <button className="profile-close" onClick={onClose}>×</button>
        <h2>Profile</h2>

        <div className="profile-section">
          <h3>User information</h3>
          <div className="profile-info">
            <div className="profile-field">
              <span className="profile-label">Username:</span>
              <span className="profile-value">{user.username}</span>
            </div>
            <div className="profile-field">
              <span className="profile-label">Email:</span>
              <span className="profile-value">{user.email}</span>
            </div>
            <div className="profile-field">
              <span className="profile-label">Status:</span>
              <span className={`profile-value ${user.is_premium ? 'premium' : 'free'}`}>
                {user.is_premium ? '⭐ Premium' : 'Free'}
              </span>
            </div>
          </div>
        </div>

        {rateLimit && (
          <div className="profile-section">
            <h3>Request limits</h3>
            <div className="rate-limit-info">
              <div className="rate-limit-bar">
                <div
                  className="rate-limit-progress"
                  style={{
                    width: `${(rateLimit.used / rateLimit.limit) * 100}%`,
                    backgroundColor: rateLimit.used >= rateLimit.limit ? '#dc3545' : '#28a745',
                  }}
                />
              </div>
              <div className="rate-limit-text">
                Used: <strong>{rateLimit.used}</strong> of <strong>{rateLimit.limit}</strong> requests today
              </div>
              <div className="rate-limit-remaining">
                Remaining: <strong>{rateLimit.remaining}</strong> requests
              </div>
              {rateLimit.is_premium && (
                <div className="rate-limit-premium">
                  ⭐ You have a premium account - unlimited number of requests!
                </div>
              )}
            </div>
          </div>
        )}

        <div className="profile-actions">
          <button className="profile-logout" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;

